import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorUserRemoveEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.user.remove),
			switchMap((action) =>
				this.vendorAdminService.removeUser(action.id).pipe(
					map(() => VendorAdminActions.user.removeSuccess({ id: action.id })),
					catchError((error) =>
						of(VendorAdminActions.user.removeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
